import { Box, CircularProgress, Stack, Switch, Typography } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

const tryParseJson = (value) => {
  if (typeof value !== "string") return value;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const getAlertState = (data) => {
  if (typeof data === "boolean") return data;
  if (data && typeof data === "object" && !Array.isArray(data)) {
    if (typeof data.showAllAccessMonthlySeasonEndAlert === "boolean") {
      return data.showAllAccessMonthlySeasonEndAlert;
    }
  }
  return null;
};

export default function ShowSeasonEndAlertSettings({
  rawData,
  handleToggle,
  isUpdating = false,
}) {
  const parsed = tryParseJson(rawData);
  const isEnabled = getAlertState(parsed);

  if (isEnabled === null) {
    return (
      <Typography color="error" variant="body2" sx={{ p: 2 }}>
        Invalid or empty Show Season End Alert settings JSON
      </Typography>
    );
  }

  return (
    <Stack sx={{ p: 2, height: "100%", justifyContent: "center" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
        }}
      >
        <WarningAmberRoundedIcon
          sx={{ color: isEnabled ? "success.main" : "text.disabled" }}
        />
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 700,
            color: isEnabled ? "success.dark" : "text.secondary",
            fontSize: "0.9rem",
            textTransform: "uppercase",
            letterSpacing: 0.4,
          }}
        >
          {isEnabled ? "Enabled" : "Disabled"}
        </Typography>
        <Switch
          checked={isEnabled}
          onChange={(event) => handleToggle(event.target.checked)}
          disabled={isUpdating}
          color={isEnabled ? "success" : "primary"}
        />
        {isUpdating && <CircularProgress size={16} thickness={6} />}
      </Box>
      <Typography
        variant="caption"
        sx={{
          mt: 1.5,
          textAlign: "center",
          color: "text.secondary",
          display: "block",
          lineHeight: 1.4,
        }}
      >
        Enabling this toggle will show the season end alert to users who have <b>ACTIVE</b> all access monthly subscription.
      </Typography>
    </Stack>
  );
}
